<template>
  <div class="modal fade" id="modal-decline-reason" tabindex="-1" role="dialog" aria-labelledby="modal-decline-reason" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h3>Why did you decline the request?</h3>
          <button
            v-for="option in withdrawal_options"
            :key="option.id"
            type="button"
            class="btn btn-block btn-dark"
            data-dismiss="modal"
            @click="handleDeclineVettingReasonCallback(option.id)">
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleDeclineVettingReasonCallback (reason) {
      this.$emit('input', reason)
    }
  },

  data () {
    return {
      withdrawal_options: [
        { id: 'call', label: 'Did Not Return Calls' },
        { id: 'budget', label: 'Budget Issues' },
        { id: 'not_proceeding', label: 'Request Not Proceeding' },
        { id: 'info', label: 'Only Wanted Information' },
        { id: 'covid19', label: 'COVID-19' },
        { id: 'test', label: 'Admin Test' },
        { id: 'star_uninterested', label: 'Star uninterested' },
        { id: 'converted_to_package', label: 'Converted to Package' },
        { id: 'junk_request', label: 'Junk Request' },
        { id: 'preferred_star_unavailable', label: 'Preferred star unavailable' },
        { id: 'other', label: 'Other' }
      ]
    }
  }
}
</script>
